$.widget("custom.buylotteryticketsformstep1", {
    options: {
        singleticketroundoccasions: "",
        doubleticketroundoccasions: "",
        specialticketroundoccasions: "",
        ticketimagenamesuffix: ""
    },
    _create: function () {
        var $widget = this,
            $element = $widget.element,
            $roundDropDown = $("select.dd-round", $element),
            $roundPanels = $(".roundPanel", $element),
            $dropdowns = $("select", $roundPanels),
            $buyButton = $(".btn", $element);

        function toggleRoundPanels() {
            $roundPanels.hide();

            $dropdowns.each(function () {
                $(this).val("0").change();
                $(this).trigger("statechanged");
            });

            $("#r_" + $roundDropDown.val()).fadeIn();
            $("#ri_" + $roundDropDown.val()).fadeIn();
        }


        $("#selectRoundLink").click(function (e) {
            e.preventDefault();
            $("#selectRoundLabel").hide();
            $("#selectRound").show();
        });

        $roundDropDown.change(toggleRoundPanels);

        $buyButton.click(function () {
            var $roundPanel = $roundPanels.filter("#r_" + $roundDropDown.val());
            var anySelected = false;
            $("select", $roundPanel).each(function () {
                var $this = $(this);
                if ($this.val() !== null && $this.val() !== '' && $this.val() !== '0') {
                    anySelected = true;
                }
            });
            if (!anySelected) {
                var $lastEnabledDropDown = $roundPanel.find("select").filter(":not([disabled])").last();
                $lastEnabledDropDown.val("1");
            }
        });
    }
});